import { render, staticRenderFns } from "./footerBox.vue?vue&type=template&id=4adc3faa&scoped=true&"
import script from "./footerBox.vue?vue&type=script&lang=js&"
export * from "./footerBox.vue?vue&type=script&lang=js&"
import style0 from "./footerBox.vue?vue&type=style&index=0&id=4adc3faa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4adc3faa",
  null
  
)

export default component.exports